// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBfy-tyEcDMPcIgNOlRveGilhEPvA58DW4",
  authDomain: "projectm-f5389.firebaseapp.com",
  projectId: "projectm-f5389",
  storageBucket: "projectm-f5389.firebasestorage.app",
  messagingSenderId: "421978633653",
  appId: "1:421978633653:web:c88bff7ac4b5f2576855fc",
  measurementId: "G-L4C3811NMC"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const data=getFirestore(app);
export const storage = getStorage(app);